<script setup>
import {titleCase} from "../../helpers/string";
import {computed} from "vue";

const swotSections = ['strengths', 'weaknesses', 'opportunities', 'threats'];
const swotSectionsColors = {
    'strengths': '#e8ffed',
    'weaknesses': '#ebf7fb',
    'opportunities': '#fffce6',
    'threats': '#fee',
};

const props = defineProps(['aiReportData']);

const swotReport = computed(() => {
    let report = {};

    if (props.aiReportData) {
        swotSections.forEach(section => {
            if (section in props.aiReportData) {
                report[section] = props.aiReportData[section];
            }
        });
    }

    return report;
});

const companyReport = computed(() => {
    let report = {};

    if (props.aiReportData) {
        Object.keys(props.aiReportData).forEach(section => {
            if (!swotSections.includes(section)) {
                report[section] = props.aiReportData[section];
            }
        });
    }

    return report;
});
</script>

<template>
    <div>
        <template v-if="Object.keys(swotReport).length">
            <div class="card card--agency">
                <header class="card__header">
                    <h4 class="heading4 heading4--tertiary">SWOT Analysis</h4>
                </header>

                <div class="card__content">
                    <div class="swot-section">
                        <div
                            v-for="(items, title) in swotReport"
                            :key="title"
                            class="swot-section__item"
                            :style="{ background: swotSectionsColors[title] }"
                        >
                            <h4 class="heading4 heading4--tertiary">{{titleCase(title)}}</h4>

                            <ul class="swot-section__list list">
                                <li v-for="(item, index) in items" :key="index">{{item}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="Object.keys(companyReport).length">
            <div class="card card--agency">
                <header class="card__header">
                    <h4 class="heading4 heading4--tertiary">Company Report</h4>
                </header>

                <div class="card__content">
                    <div>
                        <div v-for="(content, section) in companyReport" :key="section">
                            <div v-if="section === 'add_block'" v-html="content"/>

                            <template v-else>
                                <h5 class="heading5 heading5--secondary mb-3">{{titleCase(section)}}</h5>

                                <template v-if="Array.isArray(content)">
                                    <ul>
                                        <li v-for="(item, index) in content" :key="index">
                                            <template v-if="typeof item === 'object'">
                                                <div v-for="(subContent, subSection) in item" :key="subSection">
                                                    <h5 class="heading5 heading5--secondary mb-3">{{titleCase(subSection)}}</h5>
                                                    <p>{{subContent}}</p>
                                                </div>
                                            </template>

                                            <p v-else>{{item}}</p>
                                        </li>
                                    </ul>
                                </template>

                                <template v-else-if="typeof content === 'object'">
                                    <div class="public-content mb-4">
                                        <ul class="list" v-for="(subContent, subSection) in content" :key="subSection">
                                            <li>{{titleCase(subSection)}} {{subContent}}</li>
                                        </ul>
                                    </div>
                                </template>

                                <template v-else>
                                    <p>{{content}}</p>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped>

</style>
